module.exports = __webpack_public_path__ + "img/tournaments_1248.87959af2.png";